import axiosInstance from './api'

/**
 * Fetch group assignments (tasks assigned to multiple students)
 */
export const fetchAssignments = async () => {
	try {
		const response = await axiosInstance.get('/counseling/assignments')
		return response.data
	} catch (error) {
		console.error('Error fetching assignments:', error)
		throw error
	}
}

export const mockAssignments = [
	{
		id: 'a1',
		title: 'Career Quiz Assignment',
		students: 24,
		date: '12/10/25',
		completion: 40,
	},
	{
		id: 'a2',
		title: 'Career Quiz Assignment',
		students: 24,
		date: '12/10/25',
		completion: 40,
	},
	{
		id: 'a3',
		title: 'Career Quiz Assignment',
		students: 24,
		date: '12/10/25',
		completion: 40,
	},
	{
		id: 'a4',
		title: 'Career Quiz Assignment',
		students: 18,
		date: '12/18/25',
		completion: 65,
	},
	{
		id: 'a5',
		title: 'Essay Review Assignment',
		students: 12,
		date: '12/22/25',
		completion: 25,
	},
]
